import { put, takeLatest, call } from 'redux-saga/effects';
import plannerPostApiCaller from '../../postApiCaller';
import { API_METHOD, API_URL, POST_POI_PACKAGE_DATA_TYPE } from '../../constants';
import plannerGetApiCaller from '../../getApiCaller';
import plannerPutApiCaller from '../../putApiCaller';

const API_DATA = (payload) => {
  return plannerPostApiCaller(
    `places/nearByPlaces`,
    'POST',
    payload,
    true
  ).then((response) => {
    return response;
  });
};

const POST_POI_PACKAGE_DATA = (payload) => {
  return plannerPostApiCaller(
    API_URL.POST_POI_PACKAGE,
    API_METHOD.POST,
    payload,
    true
  ).then((response) => {
    return response;
  });
};

const PUT_POI_PACKAGE_REMOVE_POI_DATA = (payload) => {
  return plannerPutApiCaller(
    API_URL.PUT_POI_PACKAGE_REMOVE_POI,
    API_METHOD.PUT,
    payload,
    true
  ).then((response) => {
    return response;
  });
};

const GET_POI_PACKAGE_BY_ID_DATA = (payload) => {

  return plannerGetApiCaller(
    API_URL.GET_POI_PACKAGE_BY_ID.replace(':id', payload.id),
    API_METHOD.GET,
    true
  ).then((response) => {
    return response;
  });
};

export const GET_POI_POINTS = function* perform_getPOIPoints() {
  yield takeLatest('GET_POI_POINTS', function* (action) {
    yield put({ type: 'GET_POI_POINTS_STARTED' });
    try {
      const DATA = yield call(API_DATA.bind(this, action.payload));
      yield put({ type: 'GET_POI_POINTS_SUCCESS', payload: DATA });
    } catch (error) {
      yield put({ type: 'GET_POI_POINTS_FAILED', payload: error });
    }
  });
};

const postPOIPackage =function* (action) {
  yield put({ type: POST_POI_PACKAGE_DATA_TYPE.POST_POI_PACKAGE_STARTED });
  try {
    const DATA = yield call(POST_POI_PACKAGE_DATA.bind(this, action.payload));
    yield put({ type: POST_POI_PACKAGE_DATA_TYPE.POST_POI_PACKAGE_SUCCESS, payload: DATA });
  } catch (error) {
    yield put({ type: POST_POI_PACKAGE_DATA_TYPE.POST_POI_PACKAGE_FAILED, payload: error });
  }
}

const getPOIPackageById = function* (action) {
  yield put({ type: POST_POI_PACKAGE_DATA_TYPE.GET_POI_PACKAGE_BY_ID_STARTED });
  try {
    const DATA = yield call(GET_POI_PACKAGE_BY_ID_DATA.bind(this, action.payload));
    yield put({ type: POST_POI_PACKAGE_DATA_TYPE.GET_POI_PACKAGE_BY_ID_SUCCESS, payload: DATA });
  } catch (error) {
    yield put({ type: POST_POI_PACKAGE_DATA_TYPE.GET_POI_PACKAGE_BY_ID_FAILED, payload: error });
  }
}
const putPoiPackageRemovePoi = function* (action) {
  yield put({ type: POST_POI_PACKAGE_DATA_TYPE.PUT_POI_PACKAGE_REMOVE_POI_STARTED });
  try {
    const DATA = yield call(PUT_POI_PACKAGE_REMOVE_POI_DATA.bind(this, action.payload));
    yield put({ type: POST_POI_PACKAGE_DATA_TYPE.PUT_POI_PACKAGE_REMOVE_POI_SUCCESS, payload: DATA });
  } catch (error) {
    yield put({ type: POST_POI_PACKAGE_DATA_TYPE.PUT_POI_PACKAGE_REMOVE_POI_FAILED, payload: error });
  }
}

export const POST_POI_PACKAGE = function* () {
  yield takeLatest(POST_POI_PACKAGE_DATA_TYPE.POST_POI_PACKAGE,postPOIPackage );
  yield takeLatest(POST_POI_PACKAGE_DATA_TYPE.GET_POI_PACKAGE_BY_ID,getPOIPackageById );
  yield takeLatest(POST_POI_PACKAGE_DATA_TYPE.PUT_POI_PACKAGE_REMOVE_POI,putPoiPackageRemovePoi );
};
